import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import Seo from "../components/Seo";

const NewsletterRegistroExitoso = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const couponCode = location.state?.couponCode || "";
  const couponExpiresAt = location.state?.couponExpiresAt || "";
  const couponCreated = Boolean(location.state?.couponCreated);
  const couponDateText = couponExpiresAt
    ? new Date(couponExpiresAt).toLocaleDateString("es-CO")
    : "";

  return (
    <div className="min-h-[60vh] py-16">
      <Seo title="Registro Exitoso" />
      <div className="container mx-auto px-4 max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle>Datos registrados correctamente</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-gray-700">
              Gracias por suscribirte. Recibiras informacion importante, ofertas y novedades
              en tu correo y WhatsApp.
            </p>
            {couponCode && (
              <div className="rounded border border-green-200 bg-green-50 p-4 space-y-1">
                <p className="font-semibold text-green-900">
                  {couponCreated
                    ? "Tu cupon de bienvenida del 5%"
                    : "Tu cupon del 5% por suscripcion"}
                </p>
                <p className="text-green-900 text-lg font-bold tracking-wide">{couponCode}</p>
                {couponDateText && (
                  <p className="text-sm text-green-900">Vence: {couponDateText}</p>
                )}
              </div>
            )}
            <Button onClick={() => navigate("/")}>Volver al inicio</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NewsletterRegistroExitoso;
